module.exports = __webpack_public_path__ + "static/prodinity_og-6b388d2bfc58d0d1684aacc2d1607b24.jpg";